/* Café Nómada — interacciones propias (prefijo cn-) */
(function () {
  'use strict';
  window.__cnReady = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = window.cnMoney || '{{amount_with_comma_separator}} €';
    var n = (cents / 100).toFixed(2);
    var conComa = n.replace('.', ',');
    var conMiles = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') { var p = conComa.split(','); return conMiles(p[0], '.') + ',' + p[1]; }
      if (k === 'amount_no_decimals_with_comma_separator') return conMiles(String(Math.round(cents / 100)), '.');
      if (k === 'amount_no_decimals') return conMiles(String(Math.round(cents / 100)), ',');
      var q = n.split('.'); return conMiles(q[0], ',') + '.' + q[1];
    });
  }

  /* ---------- Reveals ---------- */
  function initReveal() {
    $$('.cn-hero').forEach(function (h) { requestAnimationFrame(function () { h.classList.add('cn-listo'); }); });
    var els = $$('.cn-reveal:not(.cn-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('cn-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cn-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Carrito ---------- */
  /* ---------- Máximo de unidades por pedido ---------- */
  var MAX = parseInt(window.cnMaxCarrito || 0, 10);
  var maxTexto = function () { return (window.cnMaxTexto || 'Máximo [max] unidades por pedido').replace('[max]', MAX); };
  function limitarCarrito() {
    if (!MAX) return;
    $$('cart-drawer-items, cart-items').forEach(function (cont) {
      var inputs = $$('.quantity__input[name="updates[]"]', cont);
      var total = inputs.reduce(function (s, i) { return s + (parseInt(i.value, 10) || 0); }, 0);
      inputs.forEach(function (i) {
        var plus = i.parentElement && i.parentElement.querySelector('.quantity__button[name="plus"]');
        if (plus) { plus.classList.toggle('disabled', total >= MAX); plus.disabled = total >= MAX; plus.title = total >= MAX ? maxTexto() : ''; }
      });
    });
  }
  function initLimite() {
    limitarCarrito();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !window.__cnLimite) {
      window.__cnLimite = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(limitarCarrito, 50); });
    }
    var obs = new MutationObserver(function () { limitarCarrito(); });
    $$('cart-drawer, cart-items').forEach(function (el) { obs.observe(el, { childList: true, subtree: true }); });
  }

  /* id puede ser un número o una lista de líneas [{ id, quantity }] (pack de 2). */
  function addToCart(id, qty) {
    var items = Array.isArray(id) ? id : [{ id: id, quantity: qty || 1 }];
    var total = items.reduce(function (s, it) { return s + it.quantity; }, 0);
    if (MAX) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        if ((c.item_count || 0) + total > MAX) throw new Error(maxTexto() + '. Ya tienes ' + c.item_count + ' en el carrito.');
        return addToCartRaw(items);
      });
    }
    return addToCartRaw(items);
  }

  function addToCartRaw(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message || 'No se pudo añadir');
      var drawer = $('cart-drawer');
      if (!drawer) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
      return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = new DOMParser();
          var nuevo = html.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
          var actual = $('#CartDrawer');
          if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
          var burbuja = $('#cart-icon-bubble');
          var nb = html.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (burbuja && nb) burbuja.innerHTML = nb.innerHTML;
          drawer.classList.remove('is-empty');
          if (drawer.open) drawer.open(); else drawer.classList.add('active');
        });
    });
  }

  /* ---------- Ficha de producto ---------- */
  function initProducto(root) {
    if (root.dataset.cnBound) return;
    root.dataset.cnBound = '1';
    var variants = [];
    try { variants = JSON.parse($('[data-cn-variants]', root).textContent); } catch (e) {}
    var form = $('[data-cn-form]', root);
    var idInput = $('[data-cn-id]', root);
    var btn = $('[data-cn-atc]', root);
    var label = $('[data-cn-atc-label]', root);
    var labelOk = label ? label.textContent : '';
    var errorEl = $('[data-cn-error]', root);
    var mainImg = $('.cn-gal__main img', root);
    var save = $('[data-cn-save]', root);

    function setMain(src, mediaId) {
      if (!mainImg || !src) return;
      mainImg.classList.add('cn-cambia');
      var tmp = new Image();
      tmp.onload = function () {
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
        requestAnimationFrame(function () { mainImg.classList.remove('cn-cambia'); });
      };
      tmp.src = src;
      $$('[data-cn-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', String(t.dataset.cnThumb === String(mediaId))); });
    }

    $$('[data-cn-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { setMain(t.dataset.src, t.dataset.cnThumb); });
    });

    /* Pack de 2: cantidad elegida y color de la segunda cafetera */
    var cantWrap = $('[data-cn-cant-wrap]', root);
    var cant = 1, v2 = null, actual = null;
    var buscar = function (id) { return variants.find(function (x) { return String(x.id) === String(id); }); };
    function lineas() {
      var v = buscar(idInput.value);
      if (cant !== 2) return [{ id: v.id, quantity: 1 }];
      var otra = v2 || v;
      return otra.id === v.id ? [{ id: v.id, quantity: 2 }] : [{ id: v.id, quantity: 1 }, { id: otra.id, quantity: 1 }];
    }

    function pintar(v) {
      if (!v) return;
      actual = v;
      if (idInput) idInput.value = v.id;
      var pv = v.price, pc = v.compare;
      if (cantWrap) {
        var uP = $('[data-cn-uno-precio]', cantWrap), uA = $('[data-cn-uno-antes]', cantWrap);
        if (uP) uP.textContent = money(v.price);
        if (uA) { uA.hidden = !(v.compare > v.price); uA.textContent = money(v.compare); }
        var otra = v2 || v;
        if (!v2) $$('[data-cn-var2]', cantWrap).forEach(function (x) { x.setAttribute('aria-checked', String(x.dataset.cnVar2 === String(v.id))); });
        var p2 = Number(cantWrap.dataset.p2), a2 = v.real + otra.real;
        var p2A = $('[data-cn-p2-antes]', cantWrap);
        if (p2A) p2A.textContent = money(a2);
        var p2S = $('[data-cn-p2-ahorro]', cantWrap);
        if (p2S && save) p2S.textContent = (save.dataset.plantilla || '').replace('[n]', '').replace('[e]', money(a2 - p2).replace(/[.,]00(?=\D*$)/, ''));
        if (cant === 2) { pv = p2; pc = a2; }
      }
      var precio = money(pv);
      $$('[data-cn-price], [data-cn-atc-price], [data-cn-sticky-price]', root).forEach(function (el) { el.textContent = precio; });
      var tiene = pc > pv;
      $$('[data-cn-old], [data-cn-atc-old]', root).forEach(function (el) { el.hidden = !tiene; if (tiene) el.textContent = money(pc); });
      if (save) {
        save.hidden = !tiene;
        if (tiene) save.textContent = (save.dataset.plantilla || '').replace('[n]', Math.floor((pc - pv) * 100 / pc)).replace('[e]', money(pc - pv).replace(/[.,]00(?=\D*$)/, ''));
      }
      if (btn) btn.disabled = !v.available;
      if (label) label.textContent = v.available ? labelOk : (btn.dataset.agotado || 'Agotado');
      var nombre = $('[data-cn-varname]', root);
      if (nombre) nombre.textContent = v.title;
      $$('[data-cn-var]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.cnVar === String(v.id))); });
      $$('[data-cn-opt]', root).forEach(function (b) {
        var marcado = !!v.options && v.options[Number(b.dataset.cnOpt)] === b.dataset.val;
        b.setAttribute('aria-checked', String(marcado));
        if (b.classList.contains('cn-pack')) b.setAttribute('aria-pressed', String(marcado));
      });
      $$('[data-cn-color-precio]', root).forEach(function (el) {
        if (!v.options) return;
        var sel = v.options.slice();
        sel[Number(el.dataset.cnColorI)] = el.dataset.cnColorPrecio;
        var x = variants.find(function (w) { return w.options.every(function (o, i) { return o === sel[i]; }); });
        if (x) el.textContent = x.available ? money(x.price) : (el.dataset.agotado || 'Agotada');
        var tarjeta = el.closest('.cn-pack');
        if (tarjeta) tarjeta.classList.toggle('cn-agotada', !x || !x.available);
      });
      $$('[data-cn-color-linea]', root).forEach(function (el) {
        if (v.options) el.textContent = v.options.filter(function (o, i) { return i !== Number(el.dataset.cnColorLinea); }).join(' · ');
      });
      $$('[data-cn-opt-val]', root).forEach(function (el) {
        if (v.options) el.textContent = v.options[Number(el.dataset.cnOptVal)];
      });
      if (v.img) setMain(v.img, v.media);
      $$('[data-cn-var]', root).forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.cnVar === String(v.id))); });
      $$('button[data-cn-isla-var]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.cnIslaVar === String(v.id))); });
      var islaVar = $('em[data-cn-isla-var]', root);
      if (islaVar) islaVar.textContent = cant === 2 ? (v2 && v2.id !== v.id ? v.title + ' + ' + v2.title : '2 × ' + v.title) : v.title;
      var islaImg = $('[data-cn-isla-img]', root);
      if (islaImg && v.img) islaImg.src = v.img.replace(/width=\d+/, 'width=140');
      var kit = $('[data-cn-kit]', root);
      if (kit) {
        var bloq = !('siempre' in kit.dataset) && v.title.indexOf(kit.dataset.kw) === -1;
        var estaba = kit.classList.contains('cn-kit--bloq');
        kit.classList.toggle('cn-kit--bloq', bloq);
        if (estaba && !bloq) {
          kit.classList.remove('cn-kit--abre');
          void kit.offsetWidth;
          kit.classList.add('cn-kit--abre');
        }
      }
      if (window.history && window.history.replaceState && document.body.classList.contains('template-product') !== false && /\/products\//.test(location.pathname)) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }

    $$('[data-cn-var]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = variants.find(function (x) { return String(x.id) === b.dataset.cnVar; });
        pintar(v);
      });
    });

    $$('[data-cn-opt]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var sel = (buscar(idInput.value).options || []).slice();
        sel[Number(b.dataset.cnOpt)] = b.dataset.val;
        pintar(variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); }));
      });
    });

    if (cantWrap) {
      var seg = $('[data-cn-seg]', cantWrap);
      $$('[data-cn-cant]', cantWrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var nuevo = Number(b.dataset.cnCant);
          var uno = $('[data-cn-cant="1"]', cantWrap);
          // Sin la opción «1 cafetera» a la vista, el pack se activa y desactiva con el mismo botón
          if (nuevo === 2 && cant === 2 && (!uno || uno.hidden)) nuevo = 1;
          cant = nuevo;
          $$('[data-cn-cant]', cantWrap).forEach(function (x) {
            var on = Number(x.dataset.cnCant) === cant;
            x.setAttribute('aria-pressed', String(on));
            x.setAttribute('aria-checked', String(on));
          });
          if (seg) seg.hidden = cant !== 2;
          if (cant === 2 && !v2) {
            $$('[data-cn-var2]', cantWrap).forEach(function (x) { x.setAttribute('aria-checked', String(x.dataset.cnVar2 === String(idInput.value))); });
          }
          pintar(buscar(idInput.value));
        });
      });
      $$('[data-cn-var2]', cantWrap).forEach(function (b) {
        b.addEventListener('click', function () {
          v2 = buscar(b.dataset.cnVar2);
          $$('[data-cn-var2]', cantWrap).forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
          pintar(buscar(idInput.value));
        });
      });
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (!btn || btn.disabled) return;
        btn.classList.add('cn-cargando');
        if (errorEl) errorEl.textContent = '';
        addToCart(lineas())
          .catch(function (e) { if (errorEl) errorEl.textContent = e.message; })
          .then(function () { btn.classList.remove('cn-cargando'); });
      });
    }

    var sticky = $('[data-cn-sticky]', root);
    if (sticky && btn) {
      var btnVisible = true;
      var actualizarIsla = function () {
        var on = !btnVisible && window.scrollY > 420;
        sticky.classList.toggle('cn-on', on);
        sticky.setAttribute('aria-hidden', String(!on));
        $$('button', sticky).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { btnVisible = e.isIntersecting; actualizarIsla(); });
        }).observe(btn);
      }
      window.addEventListener('scroll', actualizarIsla, { passive: true });
      var sb = $('[data-cn-sticky-btn]', sticky);
      if (sb) sb.addEventListener('click', function () {
        if (btn.disabled) return;
        var span = $('span', sb), txt = span ? span.textContent : '';
        sb.classList.add('cn-cargando');
        addToCart(lineas())
          .then(function () { if (span) { span.textContent = sb.dataset.hecho || '✓'; setTimeout(function () { span.textContent = txt; }, 1800); } })
          .catch(function (e) { if (errorEl) errorEl.textContent = e.message; })
          .then(function () { sb.classList.remove('cn-cargando'); });
      });
      $$('[data-cn-isla-var]', sticky).forEach(function (b) {
        if (!b.matches('button')) return;
        b.addEventListener('click', function () {
          var v = variants.find(function (x) { return String(x.id) === b.dataset.cnIslaVar; });
          pintar(v);
        });
      });
    }

    var opi = $('[data-cn-opi]', root);
    if (opi) {
      var citas = $$('.cn-opi__cita', opi), ci = 0;
      if (citas.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setInterval(function () {
          citas[ci].classList.remove('cn-on');
          ci = (ci + 1) % citas.length;
          citas[ci].classList.add('cn-on');
        }, 5000);
      }
    }
  }

  /* ---------- Carrusel de momentos ---------- */
  function initMomentos(root) {
    if (root.dataset.cnBound) return;
    root.dataset.cnBound = '1';
    var track = $('[data-cn-mom-track]', root);
    if (!track) return;
    var paso = function () { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : 300; };
    var p = $('[data-cn-mom-prev]', root), n = $('[data-cn-mom-next]', root);
    if (p) p.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });
  }

  /* ---------- Carrusel de vídeos ---------- */
  function initVideos(root) {
    if (root.dataset.cnBound) return;
    root.dataset.cnBound = '1';
    var track = $('[data-cn-vid-track]', root);
    var cards = $$('.cn-vcard', root);
    var vids = cards.map(function (c) { return $('video', c); }).filter(Boolean);
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.55) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
          else e.target.pause();
        });
      }, { threshold: [0, 0.55, 1] });
      vids.forEach(function (v) { io.observe(v); });
    }
    cards.forEach(function (c) {
      var v = $('video', c), snd = $('.cn-vcard__snd', c);
      if (!v) return;
      if (snd) snd.addEventListener('click', function (e) {
        e.stopPropagation();
        vids.forEach(function (o) { if (o !== v) { o.muted = true; var b = $('.cn-vcard__snd', o.closest('.cn-vcard')); if (b) b.classList.remove('cn-on'); } });
        v.muted = !v.muted;
        snd.classList.toggle('cn-on', !v.muted);
        snd.setAttribute('aria-pressed', String(!v.muted));
        if (!v.muted && v.paused) v.play();
      });
      c.addEventListener('click', function (e) {
        if (e.target.closest('.cn-vcard__snd')) return;
        if (v.paused) v.play(); else v.pause();
      });
    });
    var paso = function () { var c = track && track.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 300; };
    var p = $('[data-cn-vid-prev]', root), n = $('[data-cn-vid-next]', root);
    if (p) p.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });
  }

  /* ---------- Cuenta atrás de la oferta ---------- */
  function initOferta(root) {
    if (root.dataset.cnBound || !root.dataset.fin) return;
    root.dataset.cnBound = '1';
    var p = root.dataset.fin.split('-').map(Number);
    if (p.length !== 3 || p.some(isNaN)) return;
    var fin = new Date(p[0], p[1] - 1, p[2], 23, 59, 59);
    var txt = $('[data-cn-fecha-txt]', root);
    if (txt) txt.textContent = fin.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' });
    var c = $('[data-cn-cuenta]', root);
    if (!c) return;
    var dos = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var ms = fin - new Date();
      if (ms <= 0) {
        var fin_txt = root.dataset.expirado, t = $('[data-cn-top-txt]', root);
        if (fin_txt && t) { t.textContent = fin_txt; c.hidden = true; } else { root.hidden = true; }
        return false;
      }
      var s = Math.floor(ms / 1000);
      $('[data-d]', c).textContent = Math.floor(s / 86400);
      $('[data-h]', c).textContent = dos(Math.floor(s % 86400 / 3600));
      $('[data-m]', c).textContent = dos(Math.floor(s % 3600 / 60));
      $('[data-s]', c).textContent = dos(s % 60);
      return true;
    };
    if (tick()) setInterval(tick, 1000);
  }

  /* ---------- Enlaces internos (#comprar…): desplazamiento rápido y suave ----------
     Se hace a mano para que también se anime con «reducir animaciones» activado en el sistema. */
  function initAnclas() {
    if (window.__cnAnclas) return;
    window.__cnAnclas = true;
    var anim = null;
    var parar = function () { if (anim) { cancelAnimationFrame(anim); anim = null; } };
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, parar, { passive: true }); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || !url.hash || url.hash.length < 2) return;
      var destino = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!destino) return;
      e.preventDefault();
      parar();
      var margen = parseFloat(getComputedStyle(destino).scrollMarginTop) || 0;
      var desde = window.scrollY;
      var hasta = Math.max(0, destino.getBoundingClientRect().top + desde - margen);
      var dist = hasta - desde;
      var dur = Math.min(900, 380 + Math.abs(dist) * 0.18);
      var t0 = null;
      var suave = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
      var paso = function (ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        window.scrollTo({ top: desde + dist * suave(p), behavior: 'instant' });
        if (p < 1) anim = requestAnimationFrame(paso); else anim = null;
      };
      anim = requestAnimationFrame(paso);
      // Por si el navegador no pinta fotogramas (pestaña en segundo plano): llegar igualmente
      setTimeout(function () { if (anim) { parar(); window.scrollTo({ top: hasta, behavior: 'instant' }); } }, dur + 250);
      if (history.replaceState) history.replaceState(null, '', url.hash);
    });
  }

  // Plazos de entrega: fechas en días laborables desde hoy (hora de España) y cuenta atrás hasta la hora límite
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  function initEntrega(el) {
    if (el.dataset.cnListo) return;
    el.dataset.cnListo = '1';
    var corte = parseInt(el.dataset.corte, 10) || 24;
    var rango = function (s) { var p = s.split('-'); var a = parseInt(p[0], 10) || 0; var b = parseInt(p[1], 10) || a; return [Math.min(a, b), Math.max(a, b)]; };
    var reparto = rango(el.dataset.reparto), llega = rango(el.dataset.llega);
    var $t = el.querySelector('[data-cn-entrega-tiempo]');
    var dosD = function (n) { return (n < 10 ? '0' : '') + n; };
    var ahoraES = function () {
      var o = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (p) { o[p.type] = parseInt(p.value, 10); });
      return o;
    };
    var sumarLaborables = function (d, n) {
      d = new Date(d.getTime());
      while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); var w = d.getUTCDay(); if (w !== 0 && w !== 6) n--; }
      return d;
    };
    var fecha = function (d) { return d.getUTCDate() + ' de ' + MESES[d.getUTCMonth()]; };
    var tramo = function (a, b) {
      if (a.getTime() === b.getTime()) return fecha(a);
      if (a.getUTCMonth() === b.getUTCMonth()) return a.getUTCDate() + ' – ' + fecha(b);
      return fecha(a) + ' – ' + fecha(b);
    };
    var pintar = function () {
      var n = ahoraES();
      var min = n.hour * 60 + n.minute;
      var base = new Date(Date.UTC(n.year, n.month - 1, n.day));
      var resta = corte * 60 - min;
      if (resta <= 0) { resta += 1440; base.setUTCDate(base.getUTCDate() + 1); }
      if ($t) $t.textContent = dosD(Math.floor(resta / 60)) + ' h ' + dosD(resta % 60) + ' min';
      var r = el.querySelector('[data-cn-entrega-reparto]'), l = el.querySelector('[data-cn-entrega-llega]');
      if (r) r.textContent = tramo(sumarLaborables(base, reparto[0]), sumarLaborables(base, reparto[1]));
      if (l) l.textContent = tramo(sumarLaborables(base, llega[0]), sumarLaborables(base, llega[1]));
    };
    pintar();
    setInterval(pintar, 30000);
  }

  function init() {
    $$('[data-cn-entrega]').forEach(initEntrega);
    initAnclas();
    initReveal();
    initLimite();
    $$('[data-cn-oferta]').forEach(initOferta);
    $$('[data-cn-vid]').forEach(initVideos);
    $$('[data-cn-pdp]').forEach(initProducto);
    $$('[data-cn-mom]').forEach(initMomentos);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
